import { useCallback, useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { isMobileDevice, parseJson } from 'mmfintech-commons'
import { CheckoutFlowStep, useBTransfer, useSessionId, useUnloadBeacon } from 'mmfintech-checkout-commons'

import { DepositResult } from '../DepositResult'
import { PaymentContainer } from './CheckoutPaymentCore.styled'
import { WalletCheckout, WalletCheckoutOtp } from '../WalletCheckout'
import { CheckoutContainer, CheckoutContent, CustomPreloader, MerchantPane } from '../../components'

const CheckoutPaymentPis = () => {
  const sessionId = useSessionId()

  const { checkoutPay, logo, session, sessionFetching } = useSelector(
    ({ checkout: { checkoutPay, logo, session, sessionFetching } }) => ({
      logo,
      session,
      checkoutPay,
      sessionFetching
    }),
    shallowEqual
  )

  const [storageAccess, setStorageAccess] = useState(false)

  useUnloadBeacon(sessionId)

  const { step, logEvent, handlePayWithWallet, handlePaymentStatusResponse, initialized } = useBTransfer({
    debug: false,
    enableLogging: true,
    walletStep: CheckoutFlowStep.JETON_WALLET
  })

  const prepareResponse = useCallback(
    () =>
      session?.sessionStatus?.value === 'IN_PROGRESS'
        ? {
            result: parseJson(session?.paymentResult, session?.paymentResult),
            resultType: session?.paymentResultType,
            processingAmount: session?.processingAmount,
            processingCurrency: session?.processingCurrency
          }
        : checkoutPay,
    [checkoutPay, session]
  )

  useEffect(() => {
    if (typeof document.hasStorageAccess === 'function') {
      document.hasStorageAccess().then(response => setStorageAccess(response))
    } else {
      setStorageAccess(true)
    }
  }, [])

  useEffect(() => {
    if (prepareResponse()?.resultType === 'REDIRECT_URL') {
      logEvent('redirected_to_provider')
    }
    if (prepareResponse()?.resultType === 'IFRAME_URL' && !isMobileDevice()) {
      logEvent('open_provider_in_frame')
    }
  }, [prepareResponse()])

  return (
    <CheckoutContainer>
      <CheckoutContent>
        {sessionFetching || !initialized ? (
          <PaymentContainer>
            <CustomPreloader />
          </PaymentContainer>
        ) : (
          <>
            {step !== CheckoutFlowStep.JETON_WALLET && <MerchantPane session={session} logo={logo} />}

            {step === CheckoutFlowStep.JETON_WALLET && (
              <WalletCheckout
                pis={true}
                sessionId={sessionId}
                // onCancel={showCancelButton ? handleCancelClick : null}
                handlePay={handlePayWithWallet}
                paymentMethod='JETON'
                hasStorageAccess={storageAccess}
                setStorageAccess={setStorageAccess}
              />
            )}

            {step === CheckoutFlowStep.WALLET_OTP && (
              <WalletCheckoutOtp onSuccess={response => handlePaymentStatusResponse(response)} wallet={true} />
            )}

            {step === CheckoutFlowStep.DEPOSIT_RESULT && (
              <DepositResult session={session} sessionId={sessionId} response={prepareResponse()} />
            )}
          </>
        )}
      </CheckoutContent>
    </CheckoutContainer>
  )
}

export default CheckoutPaymentPis
